import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Flex,
  RadioGroup,
  Radio,
  Select,
  Text
} from '@chakra-ui/react';
import { OGOptionsContainer } from './ProductDetails.styled';
import Button from 'components/atoms/Button/Button';

const ProductOGPopup = ({
  nextOGDate,
  addToOGAction,
  setOpenOGModal,
  openOGModal,
  setSelectedOGDate,
  isImpulseUpsell,
  oneTimeItemPurchase,
  setOneTimeItemPurchase,
  selectedOGDate,
  isFetching
}) => {
  const [showError, setShowError] = useState(false);
  const frequencyOption = Array.from({ length: 29 }, (_, i) => i + 2);

  const ableToUpsell = isImpulseUpsell()?.ableToUpsell;
  const ableToCreateSub = isImpulseUpsell()?.ableToCreateSub;

  const onOptionSelected = oneTimeOption => {
    const oneTimeOptionBool = oneTimeOption === 'true';
    if (!ableToUpsell && oneTimeOptionBool) return;
    if (!ableToCreateSub && !oneTimeOptionBool) return;
    if (oneTimeOptionBool) setSelectedOGDate('');
    setOneTimeItemPurchase(oneTimeOptionBool);
  };

  return (
    <Modal isOpen={openOGModal} onClose={() => setOpenOGModal(false)} isCentered>
      <ModalOverlay />
      <ModalContent
        px={{ base: '24px', lg: '64px' }}
        pt={{ base: '40px', lg: '36px' }}
        pb="40px"
        maxW={'687px'}
        borderRadius={{ base: 0, lg: '12px' }}
      >
        <ModalCloseButton top={'16px'} right={'16px'} />
        <ModalBody p="0">
          <Text fontSize={24} color="var(--standard-red)" mb={2}>
            Add this to my order on {nextOGDate()}
          </Text>
          <Text mb={3}>
            Receive this item with your next subscription order scheduled to be placed on{' '}
            {nextOGDate()}
          </Text>
          <RadioGroup onChange={onOptionSelected} value={oneTimeItemPurchase} defaultValue={false}>
            <OGOptionsContainer>
              {ableToUpsell && (
                <Radio disabled={!ableToUpsell} value={true}>
                  <Text fontSize={16}>One Time Purchase</Text>
                </Radio>
              )}
              {ableToCreateSub && (
                <Flex alignContent={'center'}>
                  <Radio disabled={!ableToCreateSub} value={false}>
                    <Text fontSize={16}>Subscribe</Text>
                  </Radio>
                  <Select
                    maxW="248px"
                    ml={3}
                    onChange={e => {
                      if (!ableToCreateSub) return;
                      setOneTimeItemPurchase(false);
                      setSelectedOGDate(e.currentTarget.value);
                    }}
                    value={selectedOGDate}
                    disabled={!ableToCreateSub}
                  >
                    <option value="">Select Frequency</option>
                    {frequencyOption.map(option => (
                      <option key={option} value={option}>
                        {option} weeks
                      </option>
                    ))}
                  </Select>
                </Flex>
              )}
            </OGOptionsContainer>
          </RadioGroup>

          <Flex flexDirection={'column'} mt="32px" justifyContent={'center'}>
            {showError && (
              <Flex justifyContent={'center'} mb={2}>
                <Text color="red">Please select frequency</Text>
              </Flex>
            )}
            <Button
              theme={`primary`}
              type="buttonSubmit"
              disabled={isFetching}
              onClick={() => {
                if (isFetching) return;
                if (!oneTimeItemPurchase && selectedOGDate === '') {
                  setShowError(true);
                  return;
                }
                setShowError(false);
                return addToOGAction();
              }}
            >
              <span>Add to Autoship</span>
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default ProductOGPopup;
